import { useQuery } from "react-query";
import { CheckProfileResponse } from "../../../../models/User";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const checkProfileKey = "check-profile-key";

export async function checkProfile(): Promise<CheckProfileResponse> {
  const res = await ApiClient.get(`/CheckProfile`);
  return res.data[0];
}

export default function useFetchCheckProfile() {
  return useQuery([checkProfileKey], queryWrapper(checkProfile));
}
